import { render, staticRenderFns } from "./ContactRelationshipsView.vue?vue&type=template&id=2dc6c44f&scoped=true&lang=pug"
import script from "./ContactRelationshipsView.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipsView.vue?vue&type=script&lang=js"
import style0 from "./ContactRelationshipsView.vue?vue&type=style&index=0&id=2dc6c44f&prod&lang=scss&scoped=true"
import style1 from "./ContactRelationshipsView.vue?vue&type=style&index=1&id=2dc6c44f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6c44f",
  null
  
)

export default component.exports